import {ReactNode} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {useAppSelector} from "../../../store/hooks";
import {LeadFormCloseSnapshotRef} from "../../hooks/use_lead_form_close_snapshot_ref";
import {hitNegotiationApply} from "../../tracking/lead/hit_negotiation";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {LeadFormNegotiationSlot} from "./slots/LeadFormNegotiationSlot";
import {LeadFormBase} from "./LeadFormBase";

interface IProps {
    handleModalClose: (forceClose?: boolean) => void;
    onSuccessfulSubmit: (
        sentApplication: IApplicationData | null,
        offer?: IOfferDetailApplication,
        property?: IPropertyDetailApplication,
        recommendedFilters?: Record<string, string>
    ) => Promise<void>;
    initialLeadFormValues: IApplicationFormValues | null;
    customHeader: ReactNode;
    price: number | null;
    formCloseSnapshotRef?: LeadFormCloseSnapshotRef;
    onSubmitDraft?: (values: IApplicationFormValues) => Promise<void>;
    smsLoginErrorMessage?: string | null;
}

export const LeadFormWithNegotiation = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues, customHeader, price, formCloseSnapshotRef, onSubmitDraft, smsLoginErrorMessage} = props;

    const currency = useAppSelector((state) => state.mainLead.currency);

    if (!price) {
        return (
            <div className={loaderWrapperStyle}>
                <Loader />
            </div>
        );
    }

    return (
        <LeadFormBase<{negotiation: number}>
            formCloseSnapshotRef={formCloseSnapshotRef}
            config={{
                initialLeadFormValues,
                onSuccessfulSubmit,
                handleModalClose,
                extraDefaultValues: {negotiation: price},
                resetOnChange: [initialLeadFormValues, price],
                onBeforeSubmit: (values) => {
                    hitNegotiationApply(values.negotiation, price);
                },
                onSubmitDraft,
                transformFormValues: (values, defaultValues) => ({
                    ...defaultValues,
                    ...values
                })
            }}
            customHeader={customHeader}
            buttonText="Negocjuj cenę"
            smsLoginErrorMessage={smsLoginErrorMessage}
        >
            {({formMethods}) => <LeadFormNegotiationSlot price={price} currency={currency} formMethods={formMethods} />}
        </LeadFormBase>
    );
};

const loaderWrapperStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    md: {
        width: "50rem",
        height: "30rem"
    }
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {useAppSelector} from "../../../store/hooks";
import {LeadFormCloseSnapshotRef} from "../../hooks/use_lead_form_close_snapshot_ref";
import {hitNegotiationApply} from "../../tracking/lead/hit_negotiation";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {LeadFormNegotiationSlot} from "./slots/LeadFormNegotiationSlot";
import {LeadFormBase} from "./LeadFormBase";

interface IProps {
    handleModalClose: (forceClose?: boolean) => void;
    onSuccessfulSubmit: (
        sentApplication: IApplicationData | null,
        offer?: IOfferDetailApplication,
        property?: IPropertyDetailApplication,
        recommendedFilters?: Record<string, string>
    ) => Promise<void>;
    initialLeadFormValues: IApplicationFormValues | null;
    customHeader: ReactNode;
    price: number | null;
    formCloseSnapshotRef?: LeadFormCloseSnapshotRef;
    onSubmitDraft?: (values: IApplicationFormValues) => Promise<void>;
    smsLoginErrorMessage?: string | null;
}

export const LeadFormWithNegotiation = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues, customHeader, price, formCloseSnapshotRef, onSubmitDraft, smsLoginErrorMessage} = props;

    const currency = useAppSelector((state) => state.mainLead.currency);

    if (!price) {
        return (
            <div className={loaderWrapperStyle}>
                <Loader />
            </div>
        );
    }

    return (
        <LeadFormBase<{negotiation: number}>
            formCloseSnapshotRef={formCloseSnapshotRef}
            config={{
                initialLeadFormValues,
                onSuccessfulSubmit,
                handleModalClose,
                extraDefaultValues: {negotiation: price},
                resetOnChange: [initialLeadFormValues, price],
                onBeforeSubmit: (values) => {
                    hitNegotiationApply(values.negotiation, price);
                },
                onSubmitDraft,
                transformFormValues: (values, defaultValues) => ({
                    ...defaultValues,
                    ...values
                })
            }}
            customHeader={customHeader}
            buttonText="Negocjuj cenę"
            smsLoginErrorMessage={smsLoginErrorMessage}
        >
            {({formMethods}) => <LeadFormNegotiationSlot price={price} currency={currency} formMethods={formMethods} />}
        </LeadFormBase>
    );
};

const loaderWrapperStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    md: {
        width: "50rem",
        height: "30rem"
    }
});
